import React, {FC} from "react";
import SimpleProduct from "./SimpleProduct";

const VirtualProduct: FC<any> = ({
                                     product,
                                     layout,
                                     productSlug,
                                     dbName,
                                     rate,
                                     locale,
                                     change,
                                     getBuilderData,
                                 }) => {
    // TODO !!! change this component, when we will have virtual cart product
    return (
        <SimpleProduct
            productData={product}
            layout={layout}
            productSlug={productSlug}
            dbName={dbName}
            rate={rate}
            locale={locale}
            change={change}
            getBuilderData={getBuilderData}
        />
    )
}

export default VirtualProduct;
